export default {
  props: {
    spacesList: {
      type: Array,
      default: () => [],
    },
  },
};
